
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import store from '../../vuex/store'
import axios from 'axios'
export default {
components: {
XInput,
XButton,
Group,
Cell,
Alert,
Toast,
Loading
},
data () {
return {
showClear: false,
show: true,
warnMsgShow: false,
warnMsg: '',
email: '',
required: true,
invoiceId: '',
toastShow: false,
toastMsg: '',
loadingShow: false,
loadingText: '发送中',
btnText: '发送',
invoiceQrcode: '',
invoiceImagePath: ''
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '我的发票' )
},
created () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
this.invoiceId = this.$route.params.invoiceId
this.invoiceQrcode = encodeURIComponent( this.$route.params.invoiceQrcode === '0' ? '' : this.$route.params.invoiceQrcode )
},
methods: {
onClick ( link ) {
var _this = this
if ( _this.email && !_this.email.match( /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/ ) ) {
_this.warnMsgShow = true
_this.warnMsg = '邮箱格式不正确'
return false
}
_this.loadingShow = true
_this.btnText = '发送中...'
var param = {
'emailAddr': _this.email
}
var url = 'sendEmail'
if ( _this.invoiceId ) {
param = {
'emailAddr': _this.email,
'id': _this.invoiceId
}
url = 'sendEmail2'
}
param.invoiceQrcode = _this.invoiceQrcode
axios.post( _this.ajaxFactory.get( url ), {}, { params: param } ).then( function ( response ) {
var result = response.data
_this.loadingShow = false
_this.btnText = '发送'
if ( result.code === '200' ) {
_this.toastShow = true
_this.toastMsg = '发送成功'
setTimeout( function () {
window.history.go( -1 )
}, 3000 )
} else {
_this.warnMsgShow = true
_this.warnMsg = result.msg
}
} ).catch( function ( response ) {
_this.loadingShow = false
_this.btnText = '发送'
console.log( response )
} )
}
}
}



// WEBPACK FOOTER //
// ./src/components/fpj/mail.vue